module.exports = "/build/web/svg/tickets.8879f85e30f09e205d0d930bedbe1c27.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/tickets.svg
// module id = 234
// module chunks = 24